<template>
    <div>
        <b-navbar toggleable="lg" class="scrolled" fixed="top">
            <b-navbar-brand href="#">
                <router-link :to="{ name: 'hoteles' }">
                    <b-img class="mx-4" width="150px"
                        :src="require('@/assets/css/img/logo.png')">
                    </b-img>
                </router-link>
            </b-navbar-brand>
            <b-navbar-toggle target="nav_menu"></b-navbar-toggle>

            <b-collapse id="nav_menu" is-nav>
            <!-- Menu -->
                <b-navbar-nav class="col-9">
                        <b-nav-item :to="{name: 'hoteles'}" exact>HOTELES</b-nav-item>
                        <b-nav-item :to="{name: 'rutas'}" exact>RUTAS</b-nav-item>
                        <b-nav-item :to="{name: 'ofertas'}" exact>OFERTAS</b-nav-item>
                        <b-nav-item :to="{name: 'folletos'}" exact>FOLLETOS</b-nav-item>
                        <b-nav-item :to="{name: 'contacto'}" exact>CONTACTO</b-nav-item>
                        <b-nav-item :to="{name: 'informacion'}" exact>INFORMACIÓN</b-nav-item>

                    <!-- <b-nav-item :to="{name: 'home'}" exact>Home</b-nav-item>
                    <b-nav-item :to="{name: 'about'}">About</b-nav-item> -->

                    <!-- <b-nav-item v-if="logueado" :to="{name: 'grid'}">Grid</b-nav-item>
                    <b-nav-item v-if="logueado" :to="{name: 'reservas'}">Reservas</b-nav-item>
                    -->
                </b-navbar-nav>
            <!-- Acceso -->
                <b-navbar-nav  class="col-3" >
                    <b-dropdown right variant="primary" size="sm">
                        <template slot="button-content">
                            <b-avatar v-if="logueado" variant="light"></b-avatar>
                            ACCESO
                        </template>
                        <div  v-if="!logueado">
                            <!-- <b-dropdown-item :to="{name: 'login'}">LOGIN</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'registro'}">REGISTRO</b-dropdown-item> -->
                            <b-dropdown-item @click="login">ACCESO</b-dropdown-item>
                            <b-dropdown-item @click="registro">REGISTRARSE</b-dropdown-item>
                        </div>
                        <div v-else>
                            <b-dropdown-item :to="{name: 'info-personal'}" variant="success">
                                <b>{{usuario}}</b><br>
                                <small>
                                <ul class="menu-opcion">
                                    <li>Datos Cuenta</li>
                                    <li>Reservas</li>
                                    <li>Notificaciones</li>
                                </ul>
                                </small>
                            </b-dropdown-item>
                            <b-dropdown-divider />
                            <b-dropdown-item @click="desconectar">Desconectar Sesion</b-dropdown-item>
                        </div>
                        <div v-if="usuario=='abakan'||usuario=='cemo'">
                            <b-dropdown-divider></b-dropdown-divider>
                            <b-dropdown-item :to="{name: 'contacto'}">Contacto</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'condiciones-generales'}">Condiciones Generales</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'politica'}">Politica de Privacidad</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'avisolegal'}">Aviso Legal</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'cookies'}">Cookies</b-dropdown-item>
                            <b-dropdown-item :to="{name: 'informacion'}">Información</b-dropdown-item>
                            <b-dropdown-item
                                @click="openAlerta" href="#"
                            >   INFORMACION
                            </b-dropdown-item>

                            <div  v-if="logueado">
                                <b-dropdown-divider></b-dropdown-divider>
                                <b-dropdown-item :to="{name: 'reservas'}">RESERVAS</b-dropdown-item>
                                <b-dropdown-item :to="{name: 'reservar'}">Reservar</b-dropdown-item>
                                <b-dropdown-item :to="{name: 'pago-tarjeta'}">Pago TARJETA</b-dropdown-item>
                            </div>
                        </div>
                        <b-dropdown-divider />

                        <div class="w-100 text-center">
                            <span class="text-primary small">version {{ version }}</span>
                        </div>
                    </b-dropdown>
                </b-navbar-nav>
            </b-collapse>
        </b-navbar>
    </div>
</template>

<script>

export default {
    name: 'AppMenu',
    components: {

    },
    data: () => ({
        //titulo: 'PAGINA WEB',
    }),
    computed: {
        logueado() {
            return this.$store.state.auth.logueado;
        },
        usuario() {
            return this.$store.state.auth.user.name;
        },
        tit() {
            return this.$store.state.G.pagina;
        },
        version() {
            return process.env.VUE_APP_VERSION;

        },

    },
    methods: {
        login() {
            //this.$root.$emit('modal','modal_login');
            this.$bvModal.show("modal_login");
        },
        registro() {
            this.$bvModal.show("modal_registro");
        },

        desconectar() {
            //alert('La sesion se ha desconectado ...');
            this.$store.commit('modal',{tit:"Desconectar",msg:"Se ha desconectado de la Sesion"});
            this.$store.commit('login_off');
            this.$router.push('/');
        },
        openAlerta() {

            this.$bvModal.msgBoxConfirm('Please confirm that you want to delete everything.', {
                title: 'Please Confirm',
                size: 'sm',
                buttonSize: 'sm',
                okVariant: 'danger',
                okTitle: 'ACEPTAR',
                cancelTitle: 'CANCELAR',
                footerClass: 'p-2',
                hideHeaderClose: false,
                centered: true
            })
            .then(value => {
                //this.boxTwo = value
                console.log(value);
            })
            .catch(error => {
                // An error occurred
                console.log(error)
            })
        }
    },

}
</script>